/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopFinishReport from './_PopFinishReport';
function FinishReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '취소', value: 0},
    {title: '중단', value: 1},
    {title: '인계', value: 2},
    {title: '종료', value: 3}
  ];
  const [modalFinishReport, setModalFinishReport] = useState(false);
  return (
    <main className="com_container p_finish_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_8">취소/중단/인계/종료 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalFinishReport(true)} className="com_btn orange s btn_plus">
              취소/중단/인계/종료 보고서 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <div className="com_btn_wrap">
                <button className="com_btn s lightBlue">보고 진행중(45)</button>
                <button className="com_btn s lightBlue">승인 완료(45)</button>
                <button className="com_btn s btn_request gray">내 보고서(45)</button>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section>
                <div className="board_select">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                    <label htmlFor="rdo01">전체</label>
                    <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                    <label htmlFor="rdo02">환불</label>
                    <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                    <label htmlFor="rdo03">수업변경</label>
                    <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                    <label htmlFor="rdo04">기존수업으로 이동</label>
                  </div>
                </div>
                <div className="board_select">
                  <div className="check">
                    <input type="radio" name="rdo" id="rdo11" className="com_chk circle" />
                    <label htmlFor="rdo11">전체</label>
                    <input type="radio" name="rdo" id="rdo12" className="com_chk circle" />
                    <label htmlFor="rdo12">국어</label>
                    <input type="radio" name="rdo" id="rdo13" className="com_chk circle" />
                    <label htmlFor="rdo13">영어</label>
                    <input type="radio" name="rdo" id="rdo14" className="com_chk circle" />
                    <label htmlFor="rdo14">수학</label>
                    <input type="radio" name="rdo" id="rdo15" className="com_chk circle" />
                    <label htmlFor="rdo15">과탐</label>
                    <input type="radio" name="rdo" id="rdo16" className="com_chk circle" />
                    <label htmlFor="rdo16">사탐</label>
                    <input type="radio" name="rdo" id="rdo17" className="com_chk circle" />
                    <label htmlFor="rdo17">수시</label>
                    <input type="radio" name="rdo" id="rdo18" className="com_chk circle" />
                    <label htmlFor="rdo18">논술</label>
                  </div>
                </div>
              </section>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="3%" />
                <col width="8%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="8%" />
                <col width="5%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
                <col width="6%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>등록자</th>
                  <th>교사</th>
                  <th>과목</th>
                  <th>타임</th>
                  <th>회차</th>
                  <th>최근 수업일</th>
                  <th>상태</th>
                  <th>담임</th>
                  <th>교사</th>
                  <th>배정</th>
                  <th>cs</th>
                  <th>환불</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>15</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>
                    <button className="name btn_link">가길동102</button>
                  </td>
                  <td>
                    <button className="name btn_link">가교사102</button>
                  </td>
                  <td>수학</td>
                  <td>5</td>
                  <td>78/32</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>인계1</td>
                  <td>
                    보고서 등록 <br />
                    인계2 <br />
                    23.05.09
                  </td>
                  <td>
                    수업 정보 <br />
                    등록 <br />
                    23.05.09
                  </td>
                  <td>
                    등록 <br />
                    인계3 <br />
                    23, 05, 10
                  </td>
                  <td className="td_point">
                    교사동의 <br />
                    23, 05, 10
                  </td>
                  <td className="td_red">-</td>
                </tr>
                {[2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{14 - idx}</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>
                        <button className="name btn_link">가길동102</button>
                      </td>
                      <td>
                        <button className="name btn_link">가교사102</button>
                      </td>
                      <td>수학</td>
                      <td>5</td>
                      <td>78/32</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td className="td_red">중단1</td>
                      <td>
                        보고서 등록 <br />
                        인계2 <br />
                        23.05.09
                      </td>
                      <td>
                        수업 정보 <br />
                        등록 <br />
                        23.05.09
                      </td>
                      <td>
                        등록 <br />
                        인계3 <br />
                        23, 05, 10
                      </td>
                      <td className="td_point">
                        교사동의
                        <br />
                        23, 05, 10
                      </td>
                      <td className="td_red">
                        코드변경 <br />
                        중단2 <br />
                        2023, 05, 10
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 담당 학생 */}
          <section className="box">
            <div className="detail_tit dot">보고서 상세</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit" /><button className="btn_delete"></button>
            </div>
            <div className="com_detail_top">
              <button className="state stop">인계</button>
              <div className="info stop">
                <p className="tit">인계3</p>
                <span className="dot"></span>
                <p className="txt">교사의 불성실 사유로 인한 중단</p>
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    <span className="desc"> (고3ㆍ경기고등학교ㆍ본사) </span>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">전화번호</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">부모폰</span>
                  <div className="cont">
                    <p className="txt">
                      <span>부)010-1234-233</span>
                      <span className="dot" />
                      <span>모)010-1234-233</span>
                    </p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">홍보</span>
                  <span className="cont">
                    <button className="name btn_link">김홍보302</button>
                  </span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">
                    <button className="name btn_link">김담임302</button>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업과목</span>
                  <span className="cont">과탐</span>
                </div>
                <div className="info">
                  <span className="tit">기수/타임</span>
                  <span className="cont">2기 / 2T</span>
                </div>
                <div className="info">
                  <span className="tit">수업상세</span>
                  <span className="cont">사회문화, 경제, 밥과정서</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업료</span>
                  <span className="cont">2,500,000</span>
                </div>
                <div className="info">
                  <span className="tit">시수</span>
                  <span className="cont">45,000</span>
                </div>
                <div className="info">
                  <span className="tit">DC금액 / 사유</span>
                  <span className="cont">50,000 / 2기 수업으로</span>
                </div>
                <div className="info">
                  <span className="tit">실 수업료</span>
                  <span className="cont com_blue_txt">2,450,000</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">완성여부</span>
                  <span className="cont">Y</span>
                </div>
                <div className="info">
                  <span className="tit">비교수업</span>
                  <span className="cont">N</span>
                </div>
                <div className="info">
                  <span className="tit">첫 수업일</span>
                  <span className="cont">2023.05.05 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">마지막 수업일</span>
                  <span className="cont">2023.05.09 19:30</span>
                </div>
                <div className="info">
                  <span className="tit">수업 장소</span>
                  <span className="cont">경기도 수원시 팔달구 팔달로1465 모여라 빌딩 203호</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">
                    진행 수업 수 /<br /> 총 수업 수
                  </span>
                  <span className="cont com_blue_txt">45 / 65</span>
                </div>
                <div className="info">
                  <span className="tit">최근 수업일</span>
                  <span className="cont com_blue_txt">2023, 05, 08 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">진행률</span>
                  <span className="cont com_blue_txt">65%</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">환불금액</span>
                  <span className="cont com_blue_txt">
                    460,000원 <br />
                    (567,000 – ((20,000X 12)) – 45,000
                  </span>
                </div>
              </div>
              <div className="board_item">
                개인 사유로 수업을 진행할 수 없습니다. <br />
                인계 합니다.
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">배정담당자</span>
                    <span className="com_icon red">이의신청</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">제 생각은 다릅니다. 이의신청합니다..</div>
              </div>
              <div className="com_comment_wrap">
                <div className="com_input_wrap flex_row">
                  <select className="select">
                    <option value="이의신청">이의신청</option>
                  </select>
                  <select className="select">
                    <option value="1수업 상태 변경">1수업 상태 변경</option>
                  </select>
                  <select className="select">
                    <option value="2수업 상태 변경">2수업 상태 변경</option>
                  </select>
                </div>
                <textarea className="textarea s" placeholder="내용 입력"></textarea>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">교사</span>
                    <button className="name">김교사205 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">제 생각은 다릅니다. 이의신청합니다..</div>
              </div>
              <div className="com_comment_wrap">
              <div className="board_subject name">수업 진행 정보 (교사 입력)</div>
                <textarea
                  name=""
                  className="textarea"
                  placeholder="* 사용 교재 :&#10;* 진도 : &#10;* 성정:&#10;* 등등 "
                />
              </div>

              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">CS팀</span>
                    <span className="com_icon red">코드변경</span>
                    <button className="name">김관리103 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">인계</span>
                    <span className="com_icon red">인계3 : 교사의 불성실 사유로 인한 중단</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">네 내용 확인했습니다. ‘승인’ 드렸습니다.</div>
              </div>

              <div className="com_comment_wrap">
                <div className="com_input_wrap flex_row">
                  <select className="select">
                    <option value="수업 상태 변경">수업 상태 변경</option>
                  </select>
                  <select className="select">
                    <option value=" 사유 변경1"> 사유 변경1</option>
                  </select>
                  <select className="select">
                    <option value=" 사유 변경2"> 사유 변경2</option>
                  </select>
                </div>
                <textarea className="textarea s" placeholder="내용 입력"></textarea>
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange s">등록</button>
            </div>
          </section>
        </section>
      </div>
      <PopFinishReport open={modalFinishReport} close={() => setModalFinishReport(false)} />
    </main>
  );
}

export default FinishReport;
